module.exports = __webpack_public_path__ + "img/scene-logistics.e6460158.jpg";